import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { setMenuAct } from "./menu.actions";
import { tap } from "rxjs";

@Injectable()
export class MenuEffects {

    private actions$ = inject(Actions);

    setMenuEffect$ = createEffect(() => this.actions$.pipe(
        ofType(setMenuAct),
        tap((action) => {
            //this.alerta.error("Se ha precentado un error interno: ", {detail: action.error.message});
        })
    ), { dispatch: false });

}